import '../scss/site.scss';
import _ from './lib/utils.js';
import './lib/fontface.js'; // Initialize font loading detection
import './lib/breakpoint.js'; // Initialize breakpoint utility

window.app = {};

import author_about from './components/author-about.js';
import author_awards from './components/author-awards.js';
import banner_author from './components/banner-author.js';
import author_listing from './components/author-listing.js';
import article_overrides from './components/article-overrides.js';
import awards from './components/awards.js';
import banner_home from './components/banner-home.js';
import banner from './components/banner.js';
import book from './components/book.js';
import book_audio from './components/book-audio.js';
import book_block from './components/book-block.js';
import book_block_hero from './components/book-block-hero.js';
import book_block_list from './components/book-block-list.js';
import book_details from './components/book-details.js';
import book_lightbox from './components/book-lightbox.js';
import book_lists from './components/book-lists.js';
import book_series from './components/book-series.js';
import modal from './components/modal.js';
import edit_list from './components/edit-list.js';
import editions from './components/editions.js';
import events_filter from './components/events-filter.js';
import feature_block_list from './components/feature-block-list.js';
import feature_block from './components/feature-block.js';
import lazy from './components/lazy.js';
import load_more_new from './components/load-more-new.js';
import map from './components/map.js';
import markers from './components/markers.min.js';
import missing_author from './components/missing-author.js';
import nav_autocomplete from './components/nav-autocomplete.js';
import nav_search from './components/nav-search.js';
import nav_tabs from './components/nav-tabs.js';
import Nav from './components/nav.js';
import newsletter_subscribe from './components/newsletter-subscribe.js';
import newsletter from './components/newsletter.js';
import page_dimmer from './components/page-dimmer.js';
import partnership_project_swiper from './components/partnership-project-swiper.js';
import promo_swiper from './components/promo-swiper.js';
import quotes from './components/quotes.js';
import remove_toggle from './components/remove-toggle.js';
import Retailers from './components/retailers.js';
import reviews from './components/reviews.js';
import createSearchClient from './components/search-client.js';
import search_page from './components/search-page.js';
import search_results from './components/search-results.js';
import swiper from './components/swiper.js';
import teachers from './components/teachers.js';
import title_bar from './components/title-bar.js';
import cookie_consent from './components/cookie-consent.js';
import analytics from './components/analytics.js';
import lazy_loading from './components/lazy-loading.js';
import promotional_banner from './components/promotional-banner.js';
import video_takeover from './components/video-takeover.js';
import AppJS from './app.js';

// Import Handlebars templates, helpers, and partials
import './templates/hbs-helpers.js';
import './templates/hbs-partials.js';
import './templates/hbs-templates.js';

article_overrides();
author_about();
author_awards();
banner_author();
author_listing();
awards();
banner_home();
banner();
book();
book_audio();
book_block();
book_block_hero();
book_block_list();
book_details();
book_lightbox();
book_lists();
book_series();
modal();
edit_list();
editions();
events_filter();
feature_block_list();
feature_block();
lazy();
load_more_new();
map();
markers();
missing_author();
nav_autocomplete();
nav_search();
nav_tabs();
Nav();
newsletter_subscribe();
newsletter();
page_dimmer();
partnership_project_swiper();
promo_swiper();
quotes();
remove_toggle();
Retailers();
reviews();
window.app.searchClient = createSearchClient();
search_page();
search_results();

// Wait for jQuery and DOM to be ready before initializing components
function initializeComponents() {
    lazy_loading();
    // author_picker();
    AppJS();    
    swiper();
    teachers();
    title_bar();
    cookie_consent();
    analytics();
    promotional_banner();
    video_takeover();
    
}

// Check if jQuery is available, if not wait for it
if (typeof jQuery !== 'undefined') {
    initializeComponents();
} else {
    // Wait for jQuery to be available
    const checkJQuery = setInterval(() => {
        if (typeof jQuery !== 'undefined') {
            clearInterval(checkJQuery);
            initializeComponents();
        }
    }, 50);
}
